
import defaultSettings from '@/settings'
const { tokenKey } = defaultSettings

export function getToken() {
  return  sessionStorage.getItem(tokenKey);
}

export function setToken(token) {
    return sessionStorage.setItem(tokenKey, token);
}

export function removeToken() {
    return sessionStorage.removeItem(tokenKey);
}

//系统登出时清除相关的sessionstore
export function sessionStorageClear(){
    window.location.reload();
    sessionStorage.removeItem('store');
    sessionStorage.removeItem(tokenKey);
}